import { Component } from 'react'
import OktaAuth from '@okta/okta-auth-js'
import { withOktaAuth } from '@okta/okta-react'
import { withRouter } from 'react-router-dom'
import { OktaConfig } from '../config'
import queryString from 'query-string'
import loSto from '../config/loSto'
import moment from 'moment'
import { LO_STO } from '../lib/constants'

class AltaisContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      authenticated: null
    }

    const isAuthenticated = this.props.authState.isAuthenticated
    if (isAuthenticated !== null) {
      this.state = { authenticated: isAuthenticated }
    } else {
      this.state = { authenticated: null }
    }

    this.altaisOktaAuth = new OktaAuth({
      url: OktaConfig.baseURL,
      issuer: OktaConfig.auth.issuer,
      clientId: OktaConfig.auth.client_id,
      redirectUri: OktaConfig.auth.redirect_uri,
      pkce: false,
      onAuthRequired: OktaConfig.auth.onAuthRequired
    })
  }

  async componentWillMount () {
    const params = queryString.parse(this.props.location.search)
    const athenaPatientId = params.athena_patient_id
    const athenaEncounterId = params.athena_encounter_id

    const version = params.v
    const clientId = version === '2' ? OktaConfig.auth.altais_client_id_v2 : OktaConfig.auth.altais_client_id

    const state = {
      vState: version
    }
    if (athenaPatientId) {
      loSto.set(LO_STO.ATHENA_PATIENT_ID, athenaPatientId)
      state.athenaPatientId = athenaPatientId
    } else {
      loSto.remove(LO_STO.ATHENA_PATIENT_ID)
    }

    if (athenaEncounterId) {
      loSto.set(LO_STO.ATHENA_ENCOUNTER_ID, athenaEncounterId)
      state.athenaEncounterId = athenaEncounterId
    } else {
      loSto.remove(LO_STO.ATHENA_ENCOUNTER_ID)
    }

    this.initializeLoSto()
    loSto.set(LO_STO.IS_ALTAIS, true)
    this.altaisOktaAuth.token.getWithRedirect({
      idp: clientId,
      responseType: 'id_token',
      responseMode: 'fragment',
      scopes: ['openid', 'email', 'profile']
      // state: JSON.stringify(state) // this isn't working right now
    })
  }

  initializeLoSto = () => {
    loSto.remove(LO_STO.CURRENT_APPT_ID)
    loSto.remove(LO_STO.LAST_OPENED_APPT)
    loSto.remove(LO_STO.CURRENT_PATIENT_ID)
    loSto.set(LO_STO.SCHEDULE_DATE, moment().format())
  }

  render () {
    return null
  }
}

export default withOktaAuth(withRouter(AltaisContainer))
